import DocumentsTab from "../../../../patient/details/documents/DocumentsTab";

export default function DocumentsDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <DocumentsTab inWorkQ={inWorkQ} />
    </div>
}
